import { GetServerSidePropsContext } from 'next';
import ContentfulProvider from '../../providers/contentful';
import {
  LegalContentPageHandlerProperties,
  LegalContentQueryResponse,
} from './legal-content-page.types';
import { legalContentQuery } from './legal-content-page.query';
import { mergeExtraFields } from './legal-content-page.utils';

export const legalContentPageHandler = async ({
  req: { opco },
  resolvedUrl,
}: GetServerSidePropsContext): Promise<LegalContentPageHandlerProperties> => {
  const contentfulResponse = await new ContentfulProvider(
    opco,
  ).makeContentfulRequest<LegalContentQueryResponse>({
    query: legalContentQuery,
  });

  const {
    data: {
      pageLegalCollection: { items },
    },
  } = contentfulResponse;

  const mergedItems = items.map(item => mergeExtraFields(item));
  return {
    data: mergedItems,
    activeUrl: resolvedUrl,
  };
};
